import {
  pgTable,
  uuid,
  text,
  timestamp,
  integer,
  jsonb,
  index,
} from "drizzle-orm/pg-core";

// ---------------------------------------------------------------------------
// Timestamp helper
// ---------------------------------------------------------------------------

const tz = { withTimezone: true } as const;

// ---------------------------------------------------------------------------
// webhook_endpoints — Tenant-registered webhook subscriptions
// ---------------------------------------------------------------------------

export const webhookEndpoints = pgTable(
  "webhook_endpoints",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    url: text("url").notNull(),
    encryptedSecret: text("encrypted_secret").notNull(), // Encrypted HMAC secret
    secretLastFour: text("secret_last_four"), // Last 4 chars for display
    events: text("events").array().notNull(), // event types to subscribe to
    status: text("status").default("active").notNull(), // active, paused, disabled
    description: text("description"),
    metadata: jsonb("metadata").default({}).notNull(),
    failureCount: integer("failure_count").default(0).notNull(),
    lastDeliveredAt: timestamp("last_delivered_at", tz),
    lastFailedAt: timestamp("last_failed_at", tz),
    createdAt: timestamp("created_at", tz).defaultNow().notNull(),
    updatedAt: timestamp("updated_at", tz).defaultNow().notNull(),
  },
  (table) => [
    index("idx_webhook_endpoints_tenant").on(table.tenantId),
    index("idx_webhook_endpoints_status").on(table.tenantId, table.status),
  ],
);

// ---------------------------------------------------------------------------
// webhook_deliveries — Individual delivery attempts for webhook events
// ---------------------------------------------------------------------------

export const webhookDeliveries = pgTable(
  "webhook_deliveries",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    endpointId: uuid("endpoint_id").notNull(),
    eventType: text("event_type").notNull(),
    eventId: text("event_id").notNull(),
    status: text("status").default("pending").notNull(), // pending, delivered, failed, dead_letter
    attempts: integer("attempts").default(0).notNull(),
    lastAttemptAt: timestamp("last_attempt_at", tz),
    responseStatus: integer("response_status"),
    responseBody: text("response_body"), // truncated to 1KB
    error: text("error"),
    nextRetryAt: timestamp("next_retry_at", tz),
    createdAt: timestamp("created_at", tz).defaultNow().notNull(),
  },
  (table) => [
    index("idx_webhook_deliveries_tenant").on(table.tenantId),
    index("idx_webhook_deliveries_endpoint").on(table.endpointId),
    index("idx_webhook_deliveries_status_retry").on(
      table.status,
      table.nextRetryAt,
    ),
  ],
);
